import { lazy, Suspense } from 'react';
import Spin from 'components/Spin';
import type { IBrandConfig } from './types';

const MissGroupSafeTermsOfService = lazy(
  () => import('pages/terms-of-service/miss-group-safe'),
);

const DSHOP_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: 'policy/dshop-policy.md',
  termsOfService: () => (
    <Suspense fallback={<Spin />}>
      <MissGroupSafeTermsOfService />
    </Suspense>
  ),
  vaultProject: 'domene_shop',
  adaChat: false,
  accountDetails: true,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  darkwebDashboardCard: false,
  defaultBillingCategoryKey: 'privacy_breach',
  downloadsRecommended: false,
  copyRightText: 'Domeneshop. All rights reserved.',
  hasCustomerServiceSupport: false,
  horizontalVaultDashboardCards: true,
  ssoRedirectURL: null,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    customerSupportTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Domene:',
        href: 'https://domene.shop/contact',
        icon: 'support-faq',
        customerSupport: true,
      },
    ],
    call: {
      active: false,
    },
    mail: {
      active: false,
    },
    email: {
      active: false,
    },
  },
};

export default DSHOP_BRAND_CONFIG;
